module.exports = __webpack_public_path__ + "img/5.6555b76a.png";